import React, { useEffect, useState } from 'react'
import { Form, Button, Select, DatePicker, Row, Col, Space } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import Scheduling from '../../../component/marketing/Scheduling'
import moment from 'moment';

const { Option } = Select
const { RangePicker } = DatePicker

const format = 'HH:mm';
// 分别是【早班（08:00-17:00）/行政班（09:00-18:00）/晚班（12:00-21:00）】，value分别是【1/2/3】
const timeStrs = ['', '08:00-17:00', '09:00-18:00', '12:00-21:00']

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 10 }
}

export default function SendCoupon() {

    const [haveNum, setHaveNum] = useState<number>(0)
    const [checkDate, setCheckDate] = useState<any>([])
    const [formInstance] = Form.useForm()
    const [saleUserList, setsaleUserList] = React.useState<any>([]);
    const [checkDatas, setCheckDatas] = React.useState([]);
    const [scheduleRemove, setScheduleRemove] = React.useState<any>([]);
    const [addVisible, setAddVisible] = React.useState<boolean>(false);
    const [employee_id_arr, set_employee_id_arr] = React.useState<any>([]);
    const [remove_date, set_remove_date] = React.useState<any>([]);
    const [schedulings, setSchedulings] = React.useState<any>([]);
    const [users, setUsers] = React.useState<any>([]);

    const [scheduleData, setScheduleData] = useState<any>({
        "schedule_work_turn_type": undefined,
        "employee_id_arr": [],
        "schedule_start_date": "",
        "schedule_end_date": "",
        "schedule_remove_date_arr": [
        ],
        "schedule_start_work_turn": "",
        "schedule_end_work_turn": ""
    })

    const disabledDate = (current: any) => {
        return current && current < moment().endOf('day');
    }

    const handleDateChange = (value: any) => {
        set_remove_date(value)
        scheduleData.schedule_remove_date_arr = value;
        setScheduleData(scheduleData)
    }

    const handleChange = (value: string) => {
        set_employee_id_arr(value)
        scheduleData.employee_id_arr = value;
        setScheduleData(scheduleData)
    }

    // 计算两个日期之间的日期
    const getAll = (begin: any, end: any) => {
        var arr: any = [];
        var ab = begin.split("-");
        var ae = end.split("-");
        var db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);

        var de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);

        var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
        var unixDe = de.getTime() - 24 * 60 * 60 * 1000;

        for (var k: any = unixDb; k <= unixDe;) {
            k = k + 24 * 60 * 60 * 1000;
            arr.push(moment(new Date(parseInt(k))).format('YYYY-MM-DD'));
        }

        setCheckDatas(arr)
        setHaveNum(arr.length)

        return arr;
    }

    const dateChange = (date: any, dateString: any) => {
        set_remove_date([])
        setCheckDate(dateString)

        scheduleData.schedule_start_date = dateString[0]
        scheduleData.schedule_end_date = dateString[1]

        setScheduleData(scheduleData)
        setScheduleRemove(getAll(dateString[0], dateString[1]))
    }

    const changes = () => {
        let obj: any = []

        for (let i in checkDatas) {
            obj.push({ work_time: timeStrs[formInstance.getFieldValue('schedule_work_turn_type')], work_date: checkDatas[i], work_turn: `${scheduleData.schedule_start_work_turn}-${scheduleData.schedule_end_work_turn}` })
        }

        scheduleData.schedule_remove_date_arr.map((item: any) => {
            obj.map((citem: any, cindex: number) => {
                if (item == citem.work_date) {
                    obj.splice(cindex, 1)
                }
            })
        })

        let user = []
        for (let i of saleUserList) {
            for (let b of scheduleData.employee_id_arr) {
                if (i.id == b) {
                    user.push(i.user_name)
                }
            }
        }

        setSchedulings(obj)
        setUsers(user)
    }

    const submit = () => {
        axiosHandleEvent.post('/markting_center/schedule/cs/add', scheduleData).then(res => {
        })
    }

    const onFinish = (values: any) => {
        scheduleData.schedule_work_turn_type = values.schedule_work_turn_type
        setScheduleData(scheduleData)

        changes()
        setAddVisible(true)
    }

    const getEmployeeList = () => {
        baseAxiosNoInfo.get("/global/employee_list", { params: { position_number: '1' } }).then((res: any) => {
            setsaleUserList(res)
        })
    }

    useEffect(() => {
        let result: any = {}
        result['range-time-picker'] = [moment('09:00', format), moment('18:00', format)]

        formInstance.setFieldsValue(result)
        getEmployeeList()
    }, [])

    return (<div className="common-level2-edit">
        {/* 营销中心 -> 客服管理 -> 客服排班 -> 新增 */}
        <h2>新增排班</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_other" onFinish={onFinish} >
                <Form.Item label="客服" name="xs" rules={[{ required: true, message: '必须选择客服' }]}>
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        value={employee_id_arr}
                        placeholder="请选择客服"
                        onChange={handleChange}
                    >
                        {saleUserList.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.user_name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="排班日期" name="pb" rules={[{ required: true, message: '必须选择排班日期' }]}>
                    <RangePicker disabledDate={disabledDate} onChange={dateChange} />
                </Form.Item>

                <Form.Item label="排班时段" name="schedule_work_turn_type" rules={[{ required: true, message: '必须选择排版时段' }]}>
                    <Select placeholder="请选择排班时段">
                        <Option value={1} key={1}>早班（08:00-17:00）</Option>
                        <Option value={2} key={2}>行政班（09:00-18:00）</Option>
                        <Option value={3} key={3}>晚班（12:00-21:00）</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="剔除日期">
                    <Select
                        mode="multiple"
                        allowClear
                        disabled={JSON.stringify(checkDate) == '[]' || haveNum == 1 ? true : false}
                        style={{ width: '100%' }}
                        placeholder='请选择剔除日期'
                        value={remove_date}
                        onChange={handleDateChange}
                    >
                        {scheduleRemove.map((item: any) => {
                            return <Option value={item} key={item}>{item}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 6, span: 10 }}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <div className={addVisible ? 'shows' : 'hides'}>
            <div className="headers">确认排班信息</div>

            <CloseOutlined className="close" onClick={() => setAddVisible(false)} />
            <Scheduling position={[1, 2]} users={users} type='客服' useData={schedulings} onChange={changes}></Scheduling>

            <div className="footer">
                <Button style={{ marginLeft: 40, marginTop: 40 }} onClick={() => setAddVisible(false)} >取消</Button>
                <Button type="primary" style={{ marginLeft: 20 }} onClick={submit}>确认</Button>
            </div>
        </div>

        {addVisible ? <div className="mask"></div> : ''}
    </div >)
}